import { Trans } from "@lingui/react/macro";
import {
  isSanityImagePresent,
  SanityImageRatio,
  ResponsiveSanityImage,
  PartialSanityImageType,
  SanityImageProps
} from "@silversea-ssc/ui-components-react";
import React from "react";
import { isPresent } from "src/utils/checks";
import * as styles from "./CruiseDrawerItineraryHeader.module.scss";

type Props = {
  hasExcursions: boolean;
  mapImage: PartialSanityImageType | undefined;
  mapRatio: SanityImageRatio["ratio"];
  mapFit: SanityImageProps["fit"];
  cruiseName: string;
};

const CruiseDrawerItineraryHeader: React.FC<Props> = ({
  hasExcursions,
  mapFit,
  mapImage,
  mapRatio,
  cruiseName
}) => {
  return (
    <>
      <div className={styles.itineraryTitle}>
        {hasExcursions && <Trans>Itinerary & Excursions</Trans>}
        {!hasExcursions && <Trans>Itinerary</Trans>}
      </div>

      {isPresent(mapImage) && isSanityImagePresent(mapImage) && (
        <SanityImageRatio
          ratio={mapRatio}
          image={mapImage}
          className={styles.mapContainer}
        >
          <ResponsiveSanityImage
            image={mapImage}
            defaultWidth={450}
            defaultHeight={520}
            alt={cruiseName}
            fit={mapFit}
            loading="eager"
          />
        </SanityImageRatio>
      )}
    </>
  );
};

export default CruiseDrawerItineraryHeader;
